import React from 'react';
import classes from './Logo.module.css';
import { NavLink } from 'react-router-dom';
import akshLogo from '../../assets/images/logo-aktion-saubere-haende.png';

const logo = (props) => {
    return (
        <NavLink
            to='/'
            className={classes.Logo}>
            <img src={akshLogo} alt="Aktion Saubere Hände" />
        </NavLink>);
}

export default logo;